export const BG_COLOR = 0xf7f8fc;
export const AXIS_COLOR = 0x444a5a;
export const AXIS_WIDTH = 2.5;
export const GRID_COLOR = 0xd0d4de;
export const GRID_WIDTH = 1;
